module.exports = __webpack_public_path__ + "static/media/clock_white.6d3c7e55.svg";